module.exports = __webpack_public_path__ + "static/media/LRLE05.5d8b1de0.jpg";